module.exports = __webpack_public_path__ + "assets/img/21-s.ec4a337.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/21-s.jpg
// module id = kHLG
// module chunks = 0